import { Component, OnInit, OnDestroy } from '@angular/core';
import { DoctorService } from '../../services/doctor.service';
import { MatSnackBar } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../services/common.service';
@Component({
  selector: 'app-petdetail',
  templateUrl: './petdetail.component.html',
  styleUrls: ['./petdetail.component.css']
})
export class PetdetailComponent implements OnInit, OnDestroy {
  upflag = 0;
  petdocs: any;
  doctor: any;
  photo = [];
  doctorname = [];
 loading= false;
 msg1: any;
 action: any;
 pid: any;
 pet: any;
 appointment: any;
 uploadFile: any;
 dtype: any;
 filename: string;
 dsub: any;
 hasBaseDropZoneOver = false;
  div1 = true;
  div2 = false;
  p = 1;
 options: Object = {
  url : 'https://passport.petcart.in/images/petimages/index.php'
  };
  options1: Object = {
    url : 'https://passport.petcart.in/images/petimages/index.php'
    };
  sizeLimit = 2000000;
   public hasAnotherDropZoneOver = false;
   public fileOverAnother(e: any): void {
     this.hasAnotherDropZoneOver = e;
   }
  constructor(private doctorService: DoctorService, private snackbar: MatSnackBar,
  private route: ActivatedRoute, private commonService: CommonService) {
    this.route.params.subscribe(params => {
      this.pid = +params['id'];
       });

       this.commonService.petflag.next(1);
   }

  ngOnInit() {
    this.loading = true;
    this.getPetAppointment();
    this.getpetDocument();
    this.doctorService.getparticulerPetdetail(this.pid)
    .subscribe(
      (x) => {
        this.pet =  x;
        this.loading = false;
      }
    );
  }

  ngOnDestroy() {
    this.commonService.petflag.next(0);
   }

  openSnackBar() {
    this.snackbar.open(this.msg1 , this.action, {
      duration: 4000,
    });
   }
   getPetAppointment() {
    this.doctorService.gePetAppointment(this.pid)
    .subscribe(
      (x) => {
        this.appointment = x;
        for (let i = 0 ; i < this.appointment.length ; i++ ) {
          this.getServiceprovidername(this.appointment[i].serviceprovider_id)
        }
      });
   }
   getServiceprovidername(sid) {
    this.doctorService.getDoctorsDetail(sid)
    .subscribe(
      (x) => {
        this.doctor = x;
        this.doctorname['id' + this.doctor[0].id] = this.doctor[0].name;
        this.photo['id' + this.doctor[0].id] = this.doctor[0].photo;
    });
  }
  uploadImage(file) {
    this.doctorService.updatepetimage(this.pid, file )
    .subscribe(
      (x) => {
        this.pet.image = this.filename;
        console.log('in petdetail');
        this.msg1 = 'image Upload successfully';
        this.openSnackBar();
      });
  }
  /* for file upload*/

  handleUpload(data): void {
    if (data && data.response) {
        data = JSON.parse(data.response);
        this.uploadFile = data;
        this.filename = data.originalName;
     }
     this.uploadImage(this.filename);
    }
    handleUploaddoc(data): void {
      this.upflag = 1
      if (data && data.response) {
          data = JSON.parse(data.response);
          this.uploadFile = data;
          this.filename = data.originalName;
       }
       this.uploadPetDocs(this.filename);
      }
      uploadPetDocs(file) {
        const apid = 0;
       this.doctorService.uploadUserpetDocument(this.pid, this.dsub, this.dtype, file, apid)
       .subscribe(
        (x) => {
          this.upflag = 2;
          this.getpetDocument();
          this.msg1 = 'document Upload successfully';
          this.openSnackBar();
        });
      }
    fileOverBase(e: any): void {
      this.hasBaseDropZoneOver = e;
    }

    beforeUpload(uploadingFile): void  {
      if (uploadingFile.size >  this.sizeLimit) {
        uploadingFile.setAbort();
        alert('File is too large');
      }
    }
    beforeUpload2(uploadingFile): void  {
      if (uploadingFile.size >  this.sizeLimit) {
        uploadingFile.setAbort();
        alert('File is too large');
      }
    }
    getpetDocument() {
      this.doctorService.getUploadDocument(this.pid)
      .subscribe(
        (x) => {
          this.petdocs = x;
        });
    }
    openUploadForm() {
      this.div1 = ! this.div1;
      this.div2 = ! this.div2;
      this.upflag = 0;
      this.dtype = null;
      this.dsub = null;
    }
    getFileExtension(fname) {
      return fname.slice((fname.lastIndexOf(".") - 1 >>> 0) + 2);
    }
}
